import React from 'react'
import CaseStudiesSidebar from './CaseStudiesSidebar'
import details1 from '../../assets/images/projects/projects-details1.jpg'
import project2 from '../../assets/images/projects/project2.jpg'


const CaseStudiesDetailsContent = ({type, title, body1, body2, body3, results, location, technologies, completionDate, hrefName, href  }) => {


    return (
        <section className="case-studies-details-area ptb-100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-md-12">
                        {/* <div className="case-studies-details-image">
                            <img src={details1} alt="about" />
                        </div> */}
                        <div className="case-studies-details-desc">
                            <span className="sub-title">{type}</span>
                            <h3>{title}</h3>
                            <p>{body1}</p>
                            <div className="row align-items-center">
                                {/* <div className="col-lg-6 col-md-6">
                                    <div className="image">
                                        <img src={project2} alt="about" />
                                    </div>
                                </div> */}

                                {/* <div className="col-lg-6 col-md-6">
                                    <div className="content">
                                        <h3>Important Facts</h3>
                                        <ul>
                                            <li>The Field of Data Science</li>
                                            <li>The Problem</li>
                                            <li>The Solution</li>
                                            <li>The Skills</li>
                                            <li>Statistics</li>
                                            <li>Mathematics</li>
                                        </ul>
                                    </div>
                                </div> */}
                            </div>
                            <p>{body2}</p>
                            <p>{body3}</p>
                            <h3>Results</h3>
                            <p>{results}</p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <CaseStudiesSidebar location={location} technologies={technologies} completionDate={completionDate} hrefName={hrefName} href={href}/>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CaseStudiesDetailsContent